export default __webpack_public_path__ + "static/media/card-failure-light.14737d2e.svg";